import React, {useState} from 'react';

import {NavLink} from 'react-router-dom';
import Router from 'router/router';
import {connect} from 'react-redux';
import * as css from './css/nav-block';
import useFetchNav from "@/hooks/useFetchNav";

function NavBlock(props) {
    const {data: nav} = useFetchNav()
    const {className, goodsCategoryList} = props;
    const [currentIndex, setCurrentIndex] = useState(0);

    function renderLinkList() {
        if (currentIndex === 0) {
            return goodsCategoryList.map(item => {
                const {id, name, isSelf} = item;

                return (
                    <css.Link
                        as={NavLink}
                        className='link'
                        key={id}
                        to={`${Router.Search.path}?categoryId=${id}&categoryName=${name}&categorySelf=${isSelf}`}
                    >
                        {name}
                    </css.Link>
                );
            });
        } else if (currentIndex === 1) {
            return (
                <>
                    {/* <css.Link>{}</css.Link> */}
                    <css.Link as={NavLink} to={Router.ShopStreet.path}>
                        {nav?.shopStreet}
                    </css.Link>
                    <css.Link as={NavLink} to={Router.News.realPath}>
                        {nav?.news}
                    </css.Link>
                    <css.Link as={NavLink} to={Router.SecKill.path}>
                        {nav?.secKill}
                    </css.Link>
                    <css.Link as={NavLink} to={Router.Merchant.path}>
                        {nav?.merchant}
                    </css.Link>
                    <css.Link as={NavLink} to={Router.Introduce.path}>
                        {nav?.introduce}
                    </css.Link>
                </>
            );
        }
    }

    return (
        <css.NavBlock className={className}>
            <div className='bg-img-wrapper'>
                <img src={require('./img/bg.png')} alt='' className='bg-img'/>
            </div>
            <css.Container>
                <div className='title'>
                    <span className='title-text'>网址导航</span>
                    <img
                        src={require('./img/arrow-up.png')}
                        alt=''
                        className='arrow-up'
                    />
                </div>
                <css.MenuFloor>
                    <div
                        className={`item ${currentIndex === 0 ? 'active' : ''}`}
                        onMouseEnter={() => {
                            setCurrentIndex(0);
                        }}
                    >
                        分类
                    </div>
                    <div
                        className={`item ${currentIndex === 1 ? 'active' : ''}`}
                        onMouseEnter={() => {
                            setCurrentIndex(1);
                        }}
                    >
                        导航
                    </div>
                </css.MenuFloor>
                <css.LinkBLockWrapper>
                    <css.LinkBlock>{renderLinkList()}</css.LinkBlock>
                </css.LinkBLockWrapper>
            </css.Container>
        </css.NavBlock>
    );
}

export default connect(state => {
    const {app} = state;
    const {goodsCategoryList} = app;

    return {
        goodsCategoryList
    };
})(NavBlock);
